import * as React from 'react';
import Grid from '@mui/material/Grid';
import {
    useParams
  } from "react-router-dom";
import Loading from '../../core/Loading';
import Page from './Page';
import { getBlog } from '../../core/Apis';


export default function Blog(props) {
      const [loading, setLoading] = React.useState(true)
      const [post, setpost] = React.useState([])
      const [cat, setcat] = React.useState([])
      const [tags, settags] = React.useState('')
      const [comments, setcomments] = React.useState([])
      let { path } = useParams();
      // Update all
        React.useEffect(() => {
            getBlog(path).then(x => {
                setpost(x.post)
                setcat(x.nCategories)
                settags(x.nTags)
                setTimeout(() => {
                    setLoading(false)
            }, 500);
        })

        }, [])


   if(loading || post.length === 0){
        return (<>
                <Loading width={"100%"} />
              </>)
    }
  return (<>
          <Grid container spacing={5} sx={{ mt: 3 }}>
             <Page post={post} cat={cat} tags={tags} comments={comments} />
          </Grid>
        </>
 );
}
